'use strict';

var AppState = require('app_state');
var FilterSelectWizardView = require('components/devices/views/common/filter_select_wizard_view');
var I18N = require('utils/i18n');
var Misc = require('utils/misc');
var OOP = require('utils/oop');

var UserGroupView = OOP.extend(
    FilterSelectWizardView,
    {
        template: require('components/devices/templates/groups/user_group'),
        ui: OOP.inheritedObj('ui', {
            edtName: '#name-edt',
            lbxSelected: '#col_multi_select',
        }),
        events: OOP.inheritedObj('events', {
            'change #col_multi_select': function () {
                this.data.selectedFields = this.ui.lbxSelected.val();
                this.showHideItemAll();
            },
            'keyup #name-edt': function () {
                this.data.name = this.ui.edtName.val();
                this.updateWizardButtons();
            },
        }),
        initialize: function (options) {
            var optData = options.data || {};
            this.base.initialize(options);
            this.data = {
                name: optData.name,
            };
            this.data.selectedFields = optData.selectedFields;
            this.data.accessRights = Misc.cloneAsJSON(optData.accessRights);

            var selection = (optData.filter || {}).selection;
            this.errors = {};
            this.filterIntf = this.installFilter(
                {
                    filter: Misc.cloneAsJSON(optData.filter),
                    selection: selection,
                },
                { noGroups: true }
            );
            this.cb = options.cb;

            var allCapabilities = AppState.getAllCapabilities();
            this.permissionsCtrl = Misc.initPermissionsControl('perm');
            this.permissionsCtrl.setBasePermissions(allCapabilities);
            this.permissionsCtrl.setCapabilities(allCapabilities);
            this.permissionsCtrl.setSelected(this.data.accessRights || {});
        },

        showHideItemAll: function () {
            var self = this;
            setTimeout(function () {
                var $ul = $('#ms-col_multi_select .ms-selection ul.ms-list');
                if (!$ul.length) return;
                $ul = $($ul[0]);
                var $all = $ul.find('li.js-select-item-all');
                $all.remove();
                if (!self.data.selectedFields || !self.data.selectedFields.length) {
                    var el = document.createElement('li');
                    var $el = $(el);
                    $el.addClass('js-select-item-all');
                    $el.addClass('ms-optgroup-label');
                    $el.text('Alle Felder sichtbar');
                    $ul[0].append(el);
                }
            });
        },

        onShow: function () {
            this.base.onShow();
            this.initControls();
        },

        onRender: function () {
            this.initControls();
        },

        initControls: function () {
            var self = this;
            this.permissionsCtrl.initEvents(function () {
                self.data.accessRights = self.permissionsCtrl.getSelected();
                self.render();
            });
            Misc.initializeMultiSelect('#col_multi_select', I18N.TR('Verfügbar'), I18N.TR('Freigegeben'));
            this.showHideItemAll();
        },

        serializeData: function () {
            var data = this.base.serializeData();
            data.data = this.data;
            data.fields = {};
            data.errors = this.errors;
            data.permData = this.permissionsCtrl.getSerializedData();
            data.isDefault = this.options.isDefault;
            data.isExpert = AppState.user.get('is_expert');

            Misc.addFieldListData(AppState.uniqueFields(undefined, undefined, 'user-group'), data.fields);
            return data;
        },

        canWizardChange: function (is, was) {
            if (this.options.isDefault) return false;
            return this.base.canWizardChange(is, was);
        },

        canWizardFinish: function () {
            if (!this.base.canWizardFinish()) return false;
            var hasName = this.data.name != undefined && this.data.name.length > 0;
            return hasName;
        },

        wizardDone: function () {
            var self = this;
            var isValid = this.wizardValidate(function (frm) {
                this.required('name', frm.data.name, I18N.TR('Der Name muss angegeben werden.'), frm.ui.edtName);
                this.maxLen(
                    'name',
                    frm.data.name,
                    100,
                    I18N.TR('Der Name darf nicht länger als 100 Zeichen sein.'),
                    frm.ui.edtName
                );
            });
            if (isValid && this.cb) {
                this.setError(undefined);
                this.data.filter = this.filterIntf.filter;
                this.cb(this.data);
            }
        },

        getTabNames: OOP.inheritedObj('getTabNames', {
            Data: I18N.TR('Daten'),
            Group: I18N.TR('Gruppe'),
        }),

        getGroupPageIdx: function () {
            return this.filterConfig.selectionTab + 1;
        },

        setError: function (errorData) {
            this.base.setError(errorData);
            this.changePage(this.selected, true);
        },
    },
    'UserGroupView'
);

module.exports = UserGroupView;
